module.exports = __webpack_public_path__ + "img/locationicon.6511d24c.svg";